export const HEADLESS_OPTIONS_LIMIT = 1000

// Guardrail against an unexpectedly large list freezing the browser, not a feature.
// A list that can legitimately exceed this belongs behind a search endpoint.
export function renderHeadlessSafeItems<T>(
  items: T[],
  maxOptions = HEADLESS_OPTIONS_LIMIT
): T[] {
  return items.slice(0, maxOptions)
}

export function isHeadlessOptionsTruncated<T>(
  items: T[],
  maxOptions = HEADLESS_OPTIONS_LIMIT
): boolean {
  return items.length > maxOptions
}
